import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import './index.css';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

//if ('serviceWorker' in navigator) {
 // window.addEventListener('load', () => {
   // navigator.serviceWorker.register('/sw.js')
     // .then(registration => {
      //  console.log('SW registrado: ', registration);
     // })
     // .catch(registrationError => {
      //  console.log('Falha ao registrar SW: ', registrationError);
     // });
 // });
//}
